import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const KelpForestsPage = () => {
  const data = getCharterBySlug('kelp-forests');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default KelpForestsPage;
